module.exports = __webpack_public_path__ + "img/eoy-giving-donate-5.cb419d5b.jpg";